// ============================================================
// PAYMENT PLANS CONSTANTS
// ============================================================

import { AlertCircle, CheckCircle2, Clock } from 'lucide-react';

export const PAYMENT_PLAN_STATUS_CONFIG = {
  PENDING_CHOICE: {
    icon: Clock,
    label: 'En attente de choix',
    className: 'bg-slate-100 text-slate-700',
    description: 'Le client doit choisir son plan de paiement',
  },
  PENDING_PAYMENT: {
    icon: Clock,
    label: 'En attente de paiement',
    className: 'bg-amber-100 text-amber-700',
    description: 'En attente du premier paiement',
  },
  IN_PROGRESS: {
    icon: CheckCircle2,
    label: 'En cours',
    className: 'bg-blue-100 text-blue-700',
    description: 'Paiements en cours',
  },
  OVERDUE: {
    icon: AlertCircle,
    label: 'En retard',
    className: 'bg-fuchsia-100 text-fuchsia-700',
    description: 'Une ou plusieurs mensualités en retard',
  },
  COMPLETED: {
    icon: CheckCircle2,
    label: 'Terminé',
    className: 'bg-emerald-100 text-emerald-700',
    description: 'Tous les paiements effectués',
  },
  CANCELLED: {
    icon: AlertCircle,
    label: 'Annulé',
    className: 'bg-red-100 text-red-700',
    description: 'Plan de paiement annulé',
  },
  // Anciens statuts (compatibilité)
  PENDING: {
    icon: Clock,
    label: 'En attente',
    className: 'bg-amber-100 text-amber-700',
    description: 'En attente',
  },
  ACTIVE: {
    icon: CheckCircle2,
    label: 'Actif',
    className: 'bg-blue-100 text-blue-700',
    description: 'Plan actif',
  },
} as const;

export const PAYMENT_PLAN_STATUS_LABELS: Record<string, string> = {
  all: 'Tous les statuts',
  PENDING_CHOICE: 'En attente de choix',
  PENDING_PAYMENT: 'En attente de paiement',
  IN_PROGRESS: 'En cours',
  OVERDUE: 'En retard',
  COMPLETED: 'Terminé',
  CANCELLED: 'Annulé',
};

export type PaymentPlanStatus = keyof typeof PAYMENT_PLAN_STATUS_CONFIG;
